//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Speaker from './speaker';
import SpeakersSliderControls from './speakersSliderControls';
import SwiperMixin from '~/mixins/swiper.mixin.js';
import ViewportMixin from '@/mixins/viewport.mixin';
import getSpeakersArray from '@/utils/event/getSpeakersArray';

export default {
  components: {
    Speaker,
    SpeakersSliderControls,
  },
  mixins: [SwiperMixin, ViewportMixin],
  data() {
    return {
      speakers: [],

      // Размеры картинки для первого спикера
      mainSpeakerImageConfig: [
        { ext: 'webp', sizes: ['238x238 1x', '476x476 2x'] },
        { ext: 'png', sizes: ['238x238 1x', '476x476 2x'] },
      ],
    };
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    count() {
      return this.speakers.length;
    },
    /** CSS стили зависят от количетсва спикеров
     *  Но максимум под слайдером выводится 5 спикеров
     *  Так что если на деле спикеров больше - возвращаем
     *  для класса всё равно 5
     */
    cssCount() {
      const length = this.speakers.length;
      return length > 5 ? 5 : length;
    },
    title() {
      return this.count > 1
        ? this.$t('eventos.speakers.titleMultiple')
        : this.$t('eventos.speakers.title');
    },
    /** Если спикеров больше двух - показываем слайдер */
    sliderMode() {
      return this.count > 2;
    },
    /** Главный спикер, который отображается на странице
     *  По-умолчанию берётся первый спикер,
     *  если слайдера нет на странице - значение всегда будет 0
     */
    selectedSpeaker() {
      return this.swiper?.activeIndex || 0;
    },
  },
  created() {
    /** Составить список спикеров, перебрав топики ивента */
    this.speakers = getSpeakersArray(this.event);
  },
  mounted() {
    this.initializeSlider();
  },
  methods: {
    /** Создать Swiper Slider из Mixin.
     *  Слайдер создаётся в элементе с ref="swiper"
     */
    initializeSlider() {
      this.autoHeight = true;
      this.threshold = 16;
      this.slidesPerView = 1;
      this._spaceBetween = 32;
      this.noOffsetAfter = true;
      if (this.sliderMode) {
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    },
    /** Ивент срабатывает при нажатии на превью под слайдером.
     *  Переключает выбранный слайд
     */
    previewOnClick(index) {
      this.swiper.slideTo(index);
    },
    /** Каждый раз, когда мы меняем высоту слайдов
     *  нужно обновить состояние свайпера, чтобы высота подстроилась
     */
    updateSwiperState() {
      this.$nextTick(() => {
        this.swiper.update();
      });
    },
  },
};
